import { GridRow } from 'ui/indexPages/tables/grid';
import { MemberRow } from './types';
import {
  OrganizationRoleCell,
  ProjectMembershipCell,
  MfaCell,
  ActionsCell,
  NameCell,
  SelectionCell,
  TimestampCell,
} from './TableCells/index';

export const TableRows = ({
  rows,
  gridLayout,
  isMfaAvailable,
}: {
  rows: MemberRow[];
  gridLayout: string;
  isMfaAvailable: boolean;
}) => (
  <>
    {rows.map((row) => (
      <GridRow key={row.id} gridLayout={gridLayout}>
        <SelectionCell row={row} />
        <NameCell row={row} />
        <OrganizationRoleCell row={row} />
        <ProjectMembershipCell row={row} />
        {isMfaAvailable && <MfaCell row={row} />}
        <TimestampCell timestamp={row.lastLoginAt} />
        <TimestampCell timestamp={row.createdAt} />
        <ActionsCell row={row} />
      </GridRow>
    ))}
  </>
);
